"use client";

import React, { useState } from 'react';

interface FAQItem {
    question: string;
    answer: string;
}

interface FaqAccordionProps {
    faqData: FAQItem[];
}

export default function FaqAccordion({ faqData }: FaqAccordionProps) {
    const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(null);

    const toggleFaq = (index: number) => {
        setOpenFaqIndex(openFaqIndex === index ? null : index);
    };

    return (
        <div className="space-y-3">
            {faqData.map((faq: FAQItem, idx: number) => (
                <article
                    key={idx}
                    className={`bg-white border rounded-2xl overflow-hidden transition-all duration-300 ${
                        openFaqIndex === idx
                            ? 'border-green-200 shadow-[0_4px_20px_-4px_rgba(16,185,129,0.12)]'
                            : 'border-slate-100 hover:border-slate-200'
                    }`}
                >
                    <button
                        className="w-full p-5 text-left font-bold flex justify-between items-center focus:outline-none group"
                        onClick={() => toggleFaq(idx)}
                        aria-expanded={openFaqIndex === idx}
                    >
                        <span className={`text-[15px] transition-colors ${openFaqIndex === idx ? "text-green-700" : "text-slate-800 group-hover:text-slate-900"}`}>
                            {faq.question}
                        </span>
                        <span className={`flex-shrink-0 w-8 h-8 rounded-xl flex items-center justify-center transition-all duration-300 ${
                            openFaqIndex === idx
                                ? 'bg-green-50 text-green-700 rotate-180'
                                : 'bg-slate-50 text-slate-400 group-hover:bg-slate-100'
                        }`}>
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" />
                            </svg>
                        </span>
                    </button>
                    <div
                        className={`transition-all duration-300 ease-in-out overflow-hidden ${
                            openFaqIndex === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                        }`}
                    >
                        <div className="px-5 pb-5 text-slate-600 text-sm leading-relaxed font-medium">
                            {faq.answer}
                        </div>
                    </div>
                </article>
            ))}
        </div>
    );
}
